import React from 'react';
import { Controller } from 'react-hook-form';
import {
  TextField,
  InputAdornment,
  Autocomplete,
  FormControl,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { StarSymbol } from '../../../Style';
const ControlledInput = ({
  name,
  control,
  defaultValue = '',
  rules = {},
  label = '',
  placeholder = '',
  fullWidth = true,
  error,
  type,
  size,
  disabled = false,
  helperText,
  startAdornment = null,
  endAdornment = null,
  InputProps = {},
  InputLabelProps = { shrink: true },
  options = null, // Pass an array of options for Autocomplete
  getOptionLabel = (option) => option.label, // Function to map options to display values
  radioOptions = [], // For RadioGroup
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field }) => {
        // Handle RadioGroup for Gender or similar inputs
        if (type === 'radio' && radioOptions.length > 0) {
          return (
            <FormControl fullWidth>
              <FormHelperText>{label}</FormHelperText>
              <RadioGroup
                {...field}
                row
                sx={{
                  gap: {
                    xs: 0, // Adjust gap for responsiveness
                    sm: 0,
                    md: 0,
                    lg: 1,
                    xl: 1,
                  },
                }}
                onChange={(e) => field.onChange(e)}
              >
                {radioOptions.map((option) => (
                  <FormControlLabel
                    key={option.value}
                    value={option.value}
                    control={<Radio />}
                    label={option.label}
                  />
                ))}
              </RadioGroup>
              <FormHelperText>
                <StarSymbol> {helperText}</StarSymbol>
              </FormHelperText>
            </FormControl>
          );
        }
        // Handle Autocomplete if options are provided
        if (options) {
          return (
            <Autocomplete
              {...field}
              options={options || []}
              componentsProps={{
                input: {
                  autoComplete: 'new-password',
                },
              }}
              getOptionLabel={(option) => (option ? option.label || '' : '')}
              onChange={(_, value) => field.onChange(value || '')}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  placeholder={placeholder}
                  fullWidth={fullWidth}
                  error={!!error}
                  type={type}
                  size={size}
                  autoComplete='new-password'
                  helperText={helperText}
                  InputProps={{
                    ...params.InputProps,

                    startAdornment: startAdornment && (
                      <InputAdornment position='start'>
                        {startAdornment}
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <>
                        {params.InputProps.endAdornment}
                        {endAdornment}
                      </>
                    ),
                    ...InputProps,
                  }}
                  InputLabelProps={InputLabelProps}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'new-password', // ✅ This is the key fix!
                  }}
                />
              )}
            />
          );
        }
        // Default TextField rendering
        return (
          <TextField
            {...field}
            label={label}
            placeholder={placeholder}
            fullWidth={fullWidth}
            error={!!error}
            disabled={disabled}
            type={type}
            helperText={helperText}
            autoComplete='new-password'
            InputProps={{
              startAdornment: startAdornment && (
                <InputAdornment position='start'>
                  {startAdornment}
                </InputAdornment>
              ),
              endAdornment: endAdornment && (
                <InputAdornment position='end'>{endAdornment}</InputAdornment>
              ),
              ...InputProps,
            }}
            InputLabelProps={InputLabelProps}
          />
        );
      }}
    />
  );
};
export default ControlledInput;
